import * as Toast from "@radix-ui/react-toast";
import PhaseSixIcon from "../phaseSixIcon/PhaseSixIcon";
import { ToastVariants } from "../../enums/toast";

interface ToastMessageProps {
    text: string;
    duration?: number;
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    toastKey?: number;
    variant?: ToastVariants;
}

const DEFAULT_DURATION_MS = 3000;

const VARIANT_CONFIG: Record<ToastVariants, { bg: string; icon: string }> = {
    [ToastVariants.SUCCESS]: { bg: "bg-p6-green", icon: "exercise-ok" },
    [ToastVariants.ERROR]: { bg: "bg-p6-red", icon: "alert" },
};

const ToastMessage = (props: ToastMessageProps) => {
    const { bg, icon } = VARIANT_CONFIG[props.variant ?? ToastVariants.SUCCESS];

    return (
        <Toast.Root
            key={props.toastKey}
            className={`${bg} flex gap-xs items-center px-s py-xs rounded-toast self-center data-[state=open]:animate-slideIn data-[state=closed]:animate-fadeOut`}
            open={props.isOpen}
            onOpenChange={props.onOpenChange}
            duration={props.duration ?? DEFAULT_DURATION_MS}
        >
            <PhaseSixIcon
                name={icon}
                className="text-xl text-white shrink-0"
            />
            <Toast.Description className="text-l font-semibold text-white">{props.text}</Toast.Description>
        </Toast.Root>
    );
};

export default ToastMessage;
